import { useState, useEffect } from 'react';
import axios from 'axios';
import { CaretDown } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ComoUsarPage() {
  const [guide, setGuide] = useState(null);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    (async () => { try { const { data } = await axios.get(`${API}/api/my-guide`); setGuide(data); } catch {} })();
  }, []);

  if (!guide || !guide.sections?.length) {
    return (
      <div className="fade-in text-center py-16" data-testid="como-usar-page">
        <p className="text-brand-muted text-sm">Guia de utilização ainda não disponível.</p>
      </div>
    );
  }

  return (
    <div className="fade-in" data-testid="como-usar-page">
      <div className="mb-5">
        <h2 className="font-heading font-medium text-xl text-brand-text">Como usar a app</h2>
        <p className="text-xs text-brand-muted mt-0.5">Guia de funcionalidades do teu programa</p>
      </div>

      <div className="space-y-2">
        {guide.sections.map((sec, idx) => (
          <div key={sec.id || idx} className="bg-white border border-brand-border rounded-2xl overflow-hidden" data-testid={`guide-item-${idx}`}>
            <button
              onClick={() => setExpanded(expanded === idx ? null : idx)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-brand-bg/30 transition-colors"
              data-testid={`guide-toggle-${idx}`}
            >
              <span className="text-sm font-medium text-brand-text">{sec.title}</span>
              <CaretDown size={14} className={`text-brand-placeholder transition-transform ${expanded === idx ? 'rotate-180' : ''}`} />
            </button>
            {expanded === idx && (
              <div className="px-4 pb-4 border-t border-brand-border/30">
                <div className="text-sm text-brand-muted leading-relaxed pt-3" dangerouslySetInnerHTML={{ __html: sec.content || '' }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
